import React, { useEffect, useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import "./style.css";

const ControlledTabs = (props) => {
  const isVertical = props.vertical === true;
  const [key, setKey] = useState(
    props.options.length > 0
      ? props.options[0]?.title?.toLowerCase()
      : undefined
  );

  useEffect(() => {
    if (!props.activeTab) return;

    const keys = (props.options || [])
      .filter(Boolean)
      .map((el) => el?.title?.toLowerCase());

    // A link can name a tab this particular record does not have: Transfer
    // Product only appears once a sample has been collected and the request
    // has reached the right status. An activeKey matching no Tab leaves the
    // strip rendered with nothing under it, which reads as a broken page,
    // so fall back to the first tab the record does have.
    setKey(
      keys.includes(props.activeTab) ? props.activeTab : keys[0]
    );
    // options is rebuilt every render, so listing it here would run this on
    // every pass; the key only has to be reconsidered when the link changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.activeTab]); // Add dependency to avoid re-rendering

  return (
    <div className={isVertical ? "tabs-vertical" : ""}>
      <Tabs
        id="controlled-tab-example"
        activeKey={key}
        onSelect={(k) => { setKey(k); props.onSelect && props.onSelect(k); }}
        className={`tab gap-3 flex-nowrap ${isVertical ? "vertical-tabs" : ""} ${props.className || ""}`}
        style={props.styles}
        mountOnEnter={props.mountOnEnter}
        unmountOnExit={props.unmountOnExit}
      >
        {props.options.map((item, i) => {
          // Check if item.isButton is true
          if (!item) return null;
          if (item?.isButton === true) {
            return (
              <Tab
                key={i}
                eventKey={`button-${i}`}
                title={
                  <button
                    className="btn btn-primary" // Adjust the button style
                    onClick={item.onClick || (() => {})} // Optional click handler
                  >
                    {item.title}
                  </button>
                }
              />
            );
          }

          // Render as a regular tab
          return (
            <Tab
              key={i}
              eventKey={item?.title?.toLowerCase()}
              title={item?.title}
            >
              {item.data}
            </Tab>
          );
        })}
      </Tabs>
    </div>
  );
};

export default ControlledTabs;
